import { useEffect } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { removeAlert } from "../redux/reducers/Alerts";
import { sendPageViewToBackend } from "./api";

type ReduxProps = {
  removeAlert: () => any;
};

const RouteChangeHandler: React.FC<ReduxProps & RouteComponentProps> = ({
  history,
  removeAlert,
}) => {
  useEffect(() => {
    removeAlert();

    const path = history.location.pathname;
    const search = history.location.search;
    const fullPath = `${path}${search}`;
    const isPricingRelated =
      path.includes("/pricing") ||
      path.includes("/account/upgrade") ||
      path.includes("/account/changePlans");
    if (isPricingRelated) {
      sendPageViewToBackend(fullPath);
    }
  }, [history.location.pathname, history.location.search]);

  return null;
};

export default connect(null, {
  removeAlert,
})(withRouter(RouteChangeHandler));
